import { createFileRoute } from '@tanstack/react-router'

import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/(customer)/_shell/contract-guarantees')({
  beforeLoad: ({ context }) => requirePermissions(context, ['contract.read']),
})
